import { FC } from 'react';
import { Button } from 'components/common/Button';
import { useTranslation } from 'react-i18next';
import s from './PaymentMethodTabs.module.css';

export type PaymentMethod = 'card' | 'bank-account';

type PaymentMethodTabsProps = {
  value: PaymentMethod;
  onChange: (value: PaymentMethod) => void;
};

export const PaymentMethodTabs: FC<PaymentMethodTabsProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={s['payment-method-tabs']}
      role='tablist'
      aria-label={t('payment.paymentMethod')}
    >
      <Button
        role='tab'
        className={s['payment-method-tabs__tab']}
        data-active={value === 'card'}
        aria-selected={value === 'card'}
        onClick={() => onChange('card')}
      >
        {t('payment.bankCard')}
      </Button>

      <Button
        role='tab'
        className={s['payment-method-tabs__tab']}
        data-active={value === 'bank-account'}
        aria-selected={value === 'bank-account'}
        onClick={() => onChange('bank-account')}
      >
        {t('payment.bankAccount')}
      </Button>
    </div>
  );
};
